module.exports = __webpack_public_path__ + "laravel.19bf4d.svg";